import React, { FC } from 'react';
import OWTag from '../../common/OWTag';

const TSStepDisplayInTimeline: FC<any> = ({ editMode, stepNo, children }): React.ReactElement => {
	return (
		<div
			className={`inline-flex flex-row items-start ${
				editMode ? '-ml-[26px] bg-[#FAFAFA] py-4 pr-4' : '-ml-[22px]'
			}`}
		>
			<div className="mt-[2px] flex flex-row items-center">
				{editMode ? (
					<div className="ml-2" />
				) : (
					<div className="ml-2 h-[2px] w-[24px] bg-[#f0f0f0]" />
				)}
				{stepNo ? <OWTag negativeMargin>{stepNo}</OWTag> : null}
			</div>
			{children}
		</div>
	);
};

export default TSStepDisplayInTimeline;
